import React, { useEffect, useRef } from 'react';
import config from '../../config';
import { commonConstant } from '../../common';

export const AmwaySeamlessRedirect = ({ redirect }) => {
  const ref = useRef();
  const lbcRedirectUri = `${config.LIFF_URL}${commonConstant.pathCloseRedirect}`;
  const redirect_uri = `${redirect}${redirect.includes('?') ? '&' : '?'}lbcRedirectUri=${lbcRedirectUri}`;
  const payload = {
    redirectUri : redirect_uri,
    headers: {
        "X-Amway-Channel": "WEB",
        "X-Amway-Tenant": "200",
        "X-Amway-Country": "th",
        "Accept-Language": "*"
    }
  }
  const state =  btoa(JSON.stringify(payload));
  useEffect(() => {
    ref.current.submit();
  }, []);
  return (
    <div>
      Loading...
      <form
        ref={ref}
        id="appForm"
        method="GET"
        action={`${config.GLUU_IDP_URL}`}
      >
        <input
          type="hidden"
          name="scope"
          value={`openid`}
        />
        <input
          type="hidden"
          name="acr_values"
          value={`social_lbc`}
        />
        <input
          type="hidden"
          name="response_type"
          value={`code`}
        />
        <input
          type="hidden"
          name="state"
          value={`${state}`}
        />
        <input
          type="hidden"
          name="nonce"
          value={`${config.GLUU_IDP_NONCE}`}
        />
        <input
          type="hidden"
          name="client_id"
          id="client_id"
          value={`${config.NGC_CLIENTID}`}
        />
        <input
          type="hidden"
          name="redirect_uri"
          id="redirect_uri"
          value={`${config.NGC_REDIRECT_URI}`}
        />
        <input
          type="hidden"
          name="redirectTargetUrl"
          value={redirect}
        />
        <input
          type="hidden"
          name="prompt"
          value={'login'}
        />
        <input style={{ display: 'none' }} type="submit" value="submit" />
      </form>
    </div>
  );
};

export default AmwaySeamlessRedirect;
